













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Doughnut, mixins } from 'vue-chartjs';
import InfoTooltip from '@/components/infoTooltip/InfoTooltip.vue';

const { reactiveData } = mixins

@Component({
  extends: Doughnut,
  name: 'YieldChartRenderer',
  mixins: [reactiveData],
})
class YieldChartRenderer extends Vue {

  public renderChart!: (chartData: any, options: any) => void;

  @Prop({ type: Number, required: true })
  private score!: number;

  @Prop({ type: String, required: true })
  private title!: string;

  private chartData!: any;

  private options = { 
    cutoutPercentage: 75,
    responsive: true,
    tooltips: {
      enabled: false
    },
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
  }

  @Watch('score', {immediate: true})
  private mountChartData(score: number) {
    this.chartData =  {
      datasets: [{
        data: [this.score, 100 - this.score],
        backgroundColor: [this.color, '#4e4a48'],
        borderWidth: 0,
      }]
    }
  }

  get color(): string {
    if (this.score > 75) {
      return '#12b500'
    }
    if (this.score >= 50) {
      return '#7c8f0e'
    }
    if (this.score >= 25) {
      return '#eece28'
    }
    return '#fc0303';
  }

  private mounted() {
    this.renderChart(this.chartData, this.options);
  }
}

@Component({
  name: 'YieldChart',
  components: {
    YieldChartRenderer,
    InfoTooltip,
  }
})
export default class YieldChart extends Vue {
  @Prop({ type: Number, required: true })
  private score!: number;

  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: String, required: true })
  private tooltipText!: string;
}
